import { dealThemePalette } from '@guryou/colors';

const switchOverrides = {
  MuiSwitch: {
    root: {
      padding: 2,
      width: 48,
      height: 28,
      '& .Mui-checked + .MuiSwitch-track': {
        backgroundColor: `${dealThemePalette.primary.dark} !important`,
        opacity: `1 !important`,
      },
    },
    track: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      backgroundColor: `${dealThemePalette.secondary.dark} !important`,
      opacity: 1,
      '&.notDefined': {
        backgroundColor: `${dealThemePalette.secondary.contrastText} !important`,
      },
    },
    thumb: {
      borderRadius: `0 !important`,
    },
    switchBase: {
      padding: 4,
      color: `${dealThemePalette.primary.contrastText} !important`,
    },
  },
};

export { switchOverrides };
